import type { Dayjs } from "utils/dayjs";

enum TimeFrameEnum {
  THIS_YEAR = "this_year",
  LAST_YEAR = "last_year",
  LAST_6_MONTHS = "last_6_months",
  LAST_12_MONTHS = "last_12_months",
  THIS_QUARTER = "this_quarter",
  LAST_QUARTER = "last_quarter",
  THIS_MONTH = "this_month",
  LAST_MONTH = "last_month",
  LAST_30_DAYS = "last_30_days",
  LAST_90_DAYS = "last_90_days",
}

const TimeFrameTitles: Record<TimeFrameEnum, string> = {
  [TimeFrameEnum.LAST_30_DAYS]: "Last 30 Days",
  [TimeFrameEnum.LAST_90_DAYS]: "Last 90 Days",
  [TimeFrameEnum.THIS_MONTH]: "This Month",
  [TimeFrameEnum.LAST_MONTH]: "Last Month",
  [TimeFrameEnum.THIS_QUARTER]: "This Quarter",
  [TimeFrameEnum.LAST_QUARTER]: "Last Quarter",
  [TimeFrameEnum.LAST_6_MONTHS]: "Last 6 Months",
  [TimeFrameEnum.LAST_12_MONTHS]: "Last 12 Months",
  [TimeFrameEnum.THIS_YEAR]: "This Year",
  [TimeFrameEnum.LAST_YEAR]: "Last Year",
};

/** The dates a timeframe covers, as of `now`. */
const timeFrameRange = (range: TimeFrameEnum, now: Dayjs): [Dayjs, Dayjs] => {
  switch (range) {
    case TimeFrameEnum.THIS_YEAR:
      return [now.startOf("year"), now.endOf("year")];
    case TimeFrameEnum.LAST_YEAR: {
      const last = now.subtract(1, "year");
      return [last.startOf("year"), last.endOf("year")];
    }
    case TimeFrameEnum.LAST_12_MONTHS:
      return [now.subtract(12, "month"), now];
    case TimeFrameEnum.LAST_6_MONTHS:
      return [now.subtract(6, "month"), now];
    case TimeFrameEnum.THIS_QUARTER:
      return [now.startOf("quarter"), now.endOf("quarter")];
    case TimeFrameEnum.LAST_QUARTER: {
      const last = now.subtract(1, "quarter");
      return [last.startOf("quarter"), last.endOf("quarter")];
    }
    case TimeFrameEnum.THIS_MONTH:
      return [now.startOf("month"), now.endOf("month")];
    case TimeFrameEnum.LAST_MONTH: {
      const last = now.subtract(1, "month");
      return [last.startOf("month"), last.endOf("month")];
    }
    case TimeFrameEnum.LAST_30_DAYS:
      return [now.subtract(30, "day"), now];
    case TimeFrameEnum.LAST_90_DAYS:
      return [now.subtract(90, "day"), now];
    default:
      return [now, now];
  }
};

export { TimeFrameEnum, TimeFrameTitles, timeFrameRange };
